<template>
  <div id="invoicePrint" style="font-size: 12px;font-family:宋体;width: 240px;height: 95px;" class="receipt">
    <div style="width: 50%;height:100%;float: left;box-sizing: border-box;padding: 0 10px;">
      <div style="text-align: center;font-size: 16px;font-weight: bold;">
        <span v-if="cityName">{{ cityName }}市</span>
        <span>医疗卫生单位门诊医药费发票</span>
      </div>
      <div style="font-size: 14px;margin-bottom: 2px;">
        <span style="visibility: hidden">医院：</span>
        {{ formData.hospitalName }}
      </div>
      <div style="font-size: 14px;margin-bottom: 2px;">
        <span style="visibility: hidden">姓名：</span>
        {{ formData.patientName }}
      </div>
      <div style="font-size: 14px;">
        <div style="width:33.3%;float: left;">
          <span style="visibility: hidden">医保证号：</span>
          {{ formData.medicalInsuranceNumber }}
        </div>
        <div style="width:33.3%;float: left;">
          <span style="visibility: hidden">人员类别：</span>
          {{ formData.psnTypeLabel }}
        </div>
        <div style="width:33.3%;float: left;">
          <span style="visibility: hidden">日期：</span>
          {{ formData.date }}
        </div>
      </div>
      <table class="table-block" border="none" cellspacing="0" style="border-collapse:collapse;width: 100%;font-size: 14px;text-align: center;">
        <tr>
          <td style="border: none" rowspan="2" colspan="1">
            <span style="visibility: hidden">收费项目</span>
          </td>
          <td style="border: none" colspan="4">
            <span style="visibility: hidden">金额</span>
          </td>
          <td style="border: none" rowspan="2" colspan="1">
            <span style="visibility: hidden">收费项目</span>
          </td>
          <td style="border: none" colspan="4">
            <span style="visibility: hidden">金额</span>
          </td>
        </tr>
        <tr>
          <td style="border: none" colspan="2">
            <span style="visibility: hidden">目录内</span>
          </td>
          <td style="border: none" colspan="2">
            <span style="visibility: hidden">目录外</span>
          </td>
          <td style="border: none" colspan="2">
            <span style="visibility: hidden">目录内</span>
          </td>
          <td style="border: none" colspan="2">
            <span style="visibility: hidden">目录外</span>
          </td>
        </tr>
        <tr>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">西药费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.westernInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.westernOutside || 0 }}</td>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">手术费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.surgeryInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.surgeryOutside || 0 }}</td>
        </tr>
        <tr>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">中成药费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.chineseInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.chineseOutside || 0 }}</td>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">化验费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.testInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.testOutside || 0 }}</td>
        </tr>
        <tr>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">中草药</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.cornInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.cornOutside || 0 }}</td>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">输血费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.bloodInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.bloodOutside || 0 }}</td>
        </tr>
        <tr>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">检查费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.checkInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.checkOutside || 0 }}</td>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">输氧费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.oxygenInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.oxygenOutside || 0 }}</td>
        </tr>
        <tr>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">治疗费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.treatmentInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.treatmentOutside || 0 }}</td>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">材料费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.materialInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.materialOutside || 0 }}</td>
        </tr>
        <tr>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">放射费</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.launchInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.launchOutside || 0 }}</td>
          <td style="border: none" colspan="1">
            <span style="visibility: hidden">其他</span>
          </td>
          <td style="border: none" colspan="2">{{ formData.otherInside || 0 }}</td>
          <td style="border: none" colspan="2">{{ formData.otherOutside || 0 }}</td>
        </tr>
        <tr>
          <td style="border: none">
            <span style="visibility: hidden">总金额</span>
          </td>
          <td style="border: none;text-align: left;" colspan="9">
            <div>
              <span style="visibility: hidden">小写：￥ </span>
              {{ formData.smallTotalAmount || 0 }}
              <span style="visibility: hidden"> 元</span>
            </div>
            <div>
              <span style="visibility: hidden">人民币大写：</span>
              {{ formData.largeTotalAmount || 0 }}
            </div>
            <div>
              <span style="visibility: hidden">其中：目录内金额：</span>
              {{ formData.catalogTotalAmount || 0 }}
              <span style="visibility: hidden"> 元</span>
            </div>
            <div style="margin-left: 40px;">
              <span style="visibility: hidden">个人医保账户结算金额：</span>
              {{ formData.medicalInsuranceAccountAmount || 0 }}
              <span style="visibility: hidden"> 元</span>
            </div>
          </td>
        </tr>
      </table>
      <div style="width: 100%;margin-top: 4px;">
        <div style="width: 50%;float: left;font-size: 14px;">
          <span style="visibility: hidden">收款员：</span>
          {{ formData.cashier }}
        </div>
        <div style="width: 50%;float: left;font-size: 14px;">
          <span style="visibility: hidden">流水号：</span>
          {{ formData.serialNumber }}
        </div>
      </div>
    </div>
    <!--<div style="height:100%;position: relative;box-sizing: border-box;float: left;">-->
    <!--  <div style="width: 100%;margin-bottom: 50px;float: left;box-sizing: border-box;padding: 0 10px;border: 1px solid red;" v-for="item in 3" :key="item">-->
    <!--    <span style="display:inline-block;font-size: 14px;">门诊收据附件</span>-->
    <!--    <span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">-->
    <!--      {{ 4 - item }}-->
    <!--    </span>-->
    <!--  </div>-->
    <!--</div>-->
    <div v-for="(item, index) in reverseAnnexList" :key="index"
         style="width: 16.6%;height:100%;float: left;font-size: 14px;position:relative ;box-sizing: border-box;padding: 0 10px;">
      <div style="margin-bottom: 50px;">门诊收据附件<span
          style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">{{
          3 - index }}</span></div>
      <div style="margin-bottom: 5px;">姓名：{{ item.name }}</div>
      <div style="margin-bottom: 120px;">项目：{{ item.item }}</div>
      <div style="position: absolute;bottom: 60px;">
        <span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;visibility: hidden">
          {{ 3 - index }}
        </span>
        <span style="visibility: hidden">￥：</span>
        {{ item.amount }}
      </div>
      <div style="position: absolute;bottom: 40px;">
        <span style="visibility: hidden">收款：</span>
      </div>
      <div style="position: absolute;bottom: 20px;">
        <span style="visibility: hidden">日期：</span>
        {{ item.settleDate.substring(0, 9) }}
      </div>
      <div style="position: absolute;bottom: 0;">
        <span style="visibility: hidden">附件不予报销</span>
      </div>
    </div>
    <!--<div v-for="(item, index) in reverseAnnexList" :key="index"-->
    <!--  style="width: 16.6%;height:100%;float: left;font-size: 14px;position:relative ;box-sizing: border-box;padding: 0 10px;">-->
    <!--  <div style="margin-bottom: 50px;">门诊收据附件<span-->
    <!--      style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">{{-->
    <!--        3 - index }}</span></div>-->
    <!--  <div style="margin-bottom: 5px;">姓名：{{ item.name }}</div>-->
    <!--  <div style="margin-bottom: 120px;">项目：{{ item.item }}</div>-->
    <!--  <div style="position: absolute;bottom: 60px;">-->
    <!--    <span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;visibility: hidden">-->
    <!--      {{ 3 - index }}-->
    <!--    </span>-->
    <!--    <span style="visibility: hidden">￥：</span>-->
    <!--    {{ item.amount }}-->
    <!--  </div>-->
    <!--  <div style="position: absolute;bottom: 40px;">-->
    <!--    <span style="visibility: hidden">收款：</span>-->
    <!--  </div>-->
    <!--  <div style="position: absolute;bottom: 20px;">-->
    <!--    <span style="visibility: hidden">日期：</span>-->
    <!--    {{ item.settleDate.substring(0, 9) }}-->
    <!--  </div>-->
    <!--  <div style="position: absolute;bottom: 0;">-->
    <!--    <span style="visibility: hidden">附件不予报销</span>-->
    <!--  </div>-->
    <!--</div>-->

    <!-- <div style="width: 16.6%;height:100%;float: left;font-size: 14px;position:relative ;box-sizing: border-box;padding: 0 10px;">
      <div style="margin-bottom: 50px;">门诊收据附件<span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">2</span></div>
      <div style="margin-bottom: 5px;">姓名：{{ formData.invoiceAttachmentList[annexLength-2].name }}</div>
      <div style="margin-bottom: 120px;">项目：{{ formData.invoiceAttachmentList[annexLength-2].item }}</div>
      <div style="position: absolute;bottom: 60px;">
        <span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">2</span>
        ￥：{{ formData.invoiceAttachmentList[annexLength-2].amount }}
      </div>
      <div style="position: absolute;bottom: 40px;">收款：</div>
      <div style="position: absolute;bottom: 20px;">日期：{{ formData.invoiceAttachmentList[annexLength-2].settleDate.substring(0,9) }}</div>
      <div style="position: absolute;bottom: 0;">附件不予报销</div>
    </div>
    <div style="width: 16.6%;height:100%;float: left;font-size: 14px;position:relative ;box-sizing: border-box;padding: 0 10px;">
      <div style="margin-bottom: 50px;">门诊收据附件<span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">1</span></div>
      <div style="margin-bottom: 5px;">姓名：{{ formData.invoiceAttachmentList[annexLength-3].name }}</div>
      <div style="margin-bottom: 120px;">项目：{{ formData.invoiceAttachmentList[annexLength-3].item }}</div>
      <div style="position: absolute;bottom: 60px;">
        <span style="display:inline-block;width: 14px;height: 14px;border:1px solid black;border-radius: 7px;line-height: 14px;text-align: center;">1</span>
        ￥：{{ formData.invoiceAttachmentList[annexLength-3].amount }}
      </div>
      <div style="position: absolute;bottom: 40px;">收款：</div>
      <div style="position: absolute;bottom: 20px;">日期：{{ formData.invoiceAttachmentList[annexLength-3].settleDate.substring(0,9) }}</div>
      <div style="position: absolute;bottom: 0;">附件不予报销</div>
    </div> -->
  </div>
</template>

<script>
import { getLodop } from '@/plugins/LodopFuncs.js';
import { BigNumber } from 'bignumber.js';
import moment from 'moment';
import Store from "@/utils/localStore/index";

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });

export default {
  name: 'invoicePrint',
  props: {
    invoiceObj: {
      type: Object,
      default: {
      },
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      printConfig: {
        paperWidth: 80,
        printDetails: '',
        printPatientName: '',
      },
      hospitalName: '',
      chargingTime: '',
      feeTime: '', // 收费时间
      viewScript: {},
      printTime: '',//打印时间
      formData: {},
    }
  },
  computed: {
    laboratoryName() {
      return this.$store.state.global.countInfo.laboratoryName;
    },
    cityName() {
      const { countInfo } = Store.get("vuex").global
      return countInfo.city ? countInfo.city : ''
    },
    reverseAnnexList() {
      let newArr = [];
      let arr = this.formData.invoiceAttachmentList
      if (arr && arr.length) {
        for (let i = arr.length - 1; i >= 0; i--) {
          newArr.push(arr[i]);
        }
        // console.log(newArr,'翻转后的数组');
      }
      return newArr
    }
  },
  watch: {
    invoiceObj(newa, olda) {
      this.formData = newa;
      console.log("cs2", this.formData)
    }
  },
  mounted() {
    this.getPrintConfig();
  },
  methods: {
    print({ isReview } = {}) {
      this.printTime = moment().format('YYYY-MM-DD HH:mm:ss');
      const { medicineValue } = this.$store.state.global.printConfig;
      this.$nextTick(() => {
        const LODOP = getLodop();
        LODOP.PRINT_INIT("医药费发票")
        LODOP.SET_LICENSES("", "94E6E7FFD51B8CCBE5F216686981579D", "C94CEE276DB2187AE6B65D56B3FC2848", "");
        // LODOP.SET_PRINT_STYLE("HOrient", 2); //设定打印项在纸张内的水平位置锁定方式 数字型，0--左边距锁定 1--右边距锁定 2--水平方向居中 3--左边距和右边距同时锁定（中间拉伸），缺省值是0
        // LODOP.SET_PRINT_PAGESIZE(2,'95mm','240mm','发票');// 1为纵向打印，2为横向打印 （方向、纸张宽度、纸张高度、纸张名字）
        // LODOP.SET_PRINT_PAGESIZE(1,'240mm','95mm','发票');// 1为纵向打印，2为横向打印 （方向、纸张宽度、纸张高度、纸张名字）
        LODOP.SET_PRINT_PAGESIZE(1);// 1为纵向打印，2为横向打印 （方向、纸张宽度、纸张高度、纸张名字）
        LODOP.ADD_PRINT_HTM("2%", "7%", "95%", "95%", document.getElementById('invoicePrint').innerHTML);
        // LODOP.SET_SHOW_MODE("LANDSCAPE_DEFROTATED",1); //横向时的正向显示
        LODOP.NewPageA(); //强制分页
        LODOP.SET_PRINTER_INDEX(-1) //指定打印设备,-1特指操作系统内设定的默认打印机
        // LODOP.SET_PRINT_MODE("RESELECT_PAGESIZE", true); // 可以自行修改打印尺寸
        LODOP.SET_PRINT_MODE("RESELECT_PRINTER", true);// 允许重选打印机
        LODOP.SET_PRINT_MODE("AUTO_CLOSE_PREWINDOW", 1); // 打印后自动关闭预览窗口
        LODOP.SET_PRINT_MODE("NOCLEAR_BORDER", true);
        // if (isReview) {
          LODOP.PREVIEW();
        // } else {
        //   LODOP.PRINT();
        // }
        // 关闭打印触发事件
        LODOP.On_Return = (taskId, value) => {
          this.$emit('reviewClose');
        }
      });
    },
    // 计算金额
    drugAmt(price, num) {
      return BN(price).multipliedBy(num).toFixed(2);
    },
    // 获取打印配置
    getPrintConfig() {
      this.$api.clinicManagement.getPrintConfit({ configType: 5 }).then((res) => {
        this.printConfig = res;
      })
    },
    // 处理小数点
    handleDecimal(value) {
      if (!value) return;
      return Number(value).toFixed(2);
    },
  }
}
</script>
<style lang="scss" scoped>
// .header-info {
//   border-bottom: 2px solid #000000;
// }
.receipt {
  // display: flex;
  width: 300px;
  // justify-content: space-between;
  // padding-left: 20px;
}

span {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: #AAAAAA;
}

.receipt {
  position: fixed;
  background: white;

  left: -5000px;
  top: -500px;
  // left: 1000px;
  // top: 100px;
  z-index: 100;

}</style>

